import React from 'react';
import { useQcWithBatch } from '../graphql/queries';
import Typo from '../teal-react/components/atoms/Typo';
import SimpleGrid from '../teal-react/components/organisms/SimpleGrid';
import SimpleTable from '../teal-react/components/organisms/SimpleTable';
import Loading from '../teal-react/components/molecules/Loading';
import Utils from '../teal-react/utils';
import { Table } from '@mui/material';
import LogoHeader from './layout/LogoHeader';
import SimpleCard from '../teal-react/components/organisms/SimpleCard';

const BlankRow = () => {
  return (
    <tr>
      <td>&nbsp;</td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
    </tr>
  );
};

const mixingInstructions = (code?: string) => {
  if (code === '960') {
    return 'ADD ingredients #1-#4 mix well then add #5 and mix till become clear then add #6 mix again till become clear; in separate container mix #7-#10 then add to mixture. If the product is too runny, adjust with TEA; if the product is too thick, adjust with oleic acid.';
  }
  if (code === '871') {
    return 'ADD half grease and ingrediants #2-#4 and half graphite FIRST, and mix for 10-15 minutes, then add the rest of the graphite and mix another 10-15 minutes, followed by adding the rest of the grease and mix for approprite amount of time. Pull sample and send to lab with batch report.';
  }
  return 'ADD raw materials in order. Allow sufficient mixing before adding each raw material. After adding all the raw materials, allow to mix for approprite time - pull sample and send to lab with batch report.';
};

const BatchViewer = ({ qc_id }: { qc_id: number }) => {
  const { data } = useQcWithBatch(qc_id);
  if (!data) {
    return <Loading />;
  }
  const qc = data.qc[0];
  const blank_rows = new Array(10 - (qc.batch?.materials?.length || 0)).fill(0);
  const mixInstruction = mixingInstructions(qc.product.code);
  const materials = qc.batch?.[0]?.materials?.length
    ? qc.batch?.[0]?.materials
    : [{ material: <span>&nbsp;</span> }];
  return (
    <SimpleCard>
      <div style={{ padding: '0 20px 10px 20px' }}>
        <SimpleGrid
          spacing={1}
          items={[
            {
              content: <LogoHeader />,
              size: 12,
            },
            {
              content: Typo.batch_header(
                'Lot #',
                qc.qc_code.split('-').slice(-1)[0]
              ),
              size: 6,
            },
            {
              content: Typo.batch_header(
                'Start Date',
                Utils.date.formatDate(qc.date) || ''
              ),
              size: 6,
            },
            {
              content: Typo.batch_header('Product #', qc.product.code),
              size: 6,
            },
            {
              content: Typo.batch_header('QC', qc.qc_code),
              size: 6,
            },
            {
              content: Typo.batch_header('Product', qc.product.name),
              size: 6,
            },
            {
              content: (
                <div style={{ borderBottom: '1px solid #333' }}>
                  {Typo.batch_header('Approval Date', ' ')}
                </div>
              ),
              size: 6,
            },

            {
              content: Typo.batch_header(
                'Quantity',
                `${qc.amount} ${qc.unit?.name || ''}`
              ),
              size: 6,
            },
            {
              content: (
                <div style={{ borderBottom: '1px solid #333' }}>
                  {Typo.batch_header('Approval Signature', ' ')}
                </div>
              ),
              size: 6,
            },
          ]}
        />
      </div>
      <SimpleTable
        noCard
        row_limit={100}
        data={materials}
        tableClassName={'plusco_table'}
        columns={[
          {
            header: 'RAW MATERIAL',
            cell: 'material',
            sort: false,
          },
          {
            header: 'AMOUNT NEEDED',
            cell: (r: any) => `${r.amount || ''} ${r.unit?.name || ''}`,
            sort: false,
          },
          {
            header: 'AMOUNT ADDED',
            cell: () => null,
            // style: { width: '150px' },
            sort: false,
          },
          {
            header: 'BLENDER',
            cell: () => null,
            style: { width: '100px' },
            sort: false,
          },
          {
            header: 'TIME',
            cell: () => null,
            style: { width: '75px' },
            sort: false,
          },
          {
            header: 'COMMENTS',
            cell: 'remark',
            style: { width: '120px' },
            sort: false,
          },
        ]}
        manual_bottom_rows={
          <>
            {blank_rows.map((e, ix: number) => (
              <BlankRow key={ix} />
            ))}
            <tr style={{ borderTop: 'double' }}>
              <td colSpan={2} style={{ padding: '.75rem' }}>
                <strong>{Typo.body('Sample Taken By:')}</strong>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr style={{ border: 'none' }}>
              <td
                colSpan={5}
                style={{
                  border: 'none',
                  padding: '.75rem',
                  textDecoration: 'underline',
                  fontWeight: 700,
                }}
              >
                MIXING INSTRUCTION
              </td>
            </tr>
            <tr style={{ border: 'none' }}>
              <td
                colSpan={5}
                style={{ border: 'none', padding: '.75rem 1rem 10rem 1rem' }}
              >
                {mixInstruction}
              </td>
            </tr>
          </>
        }
      />
      <Table className="plusco-footer-table">
        <tbody>
          <tr>
            <td>ID</td>
            <td>TITLE</td>
            <td>DOCUMENT TYPE</td>
            <td>REV #</td>
            <td>APP</td>
            <td>PAGE</td>
          </tr>
          <tr>
            <td>QAF:1</td>
            <td>PRODUCT REQUISITION FORM</td>
            <td>FORM OR EXHIBIT</td>
            <td>1-9-3-12</td>
            <td>RD</td>
            <td>1 OF 1</td>
          </tr>
        </tbody>
      </Table>
    </SimpleCard>
  );
};

export default BatchViewer;
